"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalMetric = void 0;
var ExternalMetric;
(function (ExternalMetric) {
    ExternalMetric["awsLambdaDuration"] = "aws.lambda.duration";
    ExternalMetric["awsLambdaEnhancedTimeouts"] = "aws.lambda.enhanced.timeouts";
    ExternalMetric["awsLambdaErrors"] = "aws.lambda.errors";
    ExternalMetric["awsLambdaInvocations"] = "aws.lambda.invocations";
    ExternalMetric["awsRdsCpuUtilization"] = "aws.rds.cpuutilization";
    ExternalMetric["awsRdsDbload"] = "aws.rds.dbload";
    ExternalMetric["awsSqsApproximateAgeOfOldestMessage"] = "aws.sqs.approximate_age_of_oldest_message";
    ExternalMetric["awsSqsApproximateNumberOfMessagesVisible"] = "aws.sqs.approximate_number_of_messages_visible";
    ExternalMetric["awsStepFunctionsExecutionsFailed"] = "aws.states.executions_failed";
    ExternalMetric["awsStepFunctionsExecutionsSucceeded"] = "aws.states.executions_succeeded";
    ExternalMetric["awsStepFunctionsExecutionsTimedOut"] = "aws.states.executions_timed_out";
    ExternalMetric["traceAwsSqsDuration"] = "trace.aws.sqs.duration";
    ExternalMetric["traceAwsSqsHits"] = "trace.aws.sqs.hits";
    ExternalMetric["traceKoaRequest"] = "trace.koa.request";
    ExternalMetric["traceKoaRequestHitsByHttpStatus"] = "trace.koa.request.hits.by_http_status";
})(ExternalMetric = exports.ExternalMetric || (exports.ExternalMetric = {}));
//# sourceMappingURL=externalMetrics.js.map